
export default class extends Controller {
  static targets = ['source'];

  copy(event) {
    event && event.preventDefault();
    this.copyTextareaContentToClipboard();
    this.removeTextarea()
    App.FlashAlerts.renderAlert("Link copied to clipboard", "notice")
  }

  createTextarea() {
    var textarea = document.createElement('textarea');
    textarea.value = this.sourceTarget.href;
    return textarea
  }

  prepTextArea(textarea) {
    textarea.setAttribute('readonly', '');
    textarea.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(textarea);
  }

  copyTextareaContentToClipboard() {
    this.textarea.select();
    document.execCommand('copy');
  }

  removeTextarea() {
    document.body.removeChild(this.textarea);
    this._textarea = null;
  }

  get textarea() {
    if (!this._textarea) {
      this._textarea = this.createTextarea()
      this.prepTextArea(this._textarea)
    }
    return this._textarea
  }
};



// WEBPACK FOOTER //
// ./app/components/controls/assets/javascript/controls-anchor-link-controller.js